import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { OrganizationRoleCredentialPresentation } from 'features/organization-settings/organization-roles/organization-roles.constants';
import { SmartTable } from '@certemy/ui-components';

@Component({
  selector: 'cm-active-credentials-table-modal',
  templateUrl: './active-credentials-table-modal.html',
  styleUrls: ['./active-credentials-table-modal.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActiveCredentialsTableModalComponent {
  @Input() rows: OrganizationRoleCredentialPresentation[];

  readonly TABLE_HEADERS: SmartTable.Header[] = [
    { name: 'Credential Acronym', value: 'acronym', type: SmartTable.ColumnTypeId.STRING },
    { name: 'Credential Name', value: 'name', type: SmartTable.ColumnTypeId.STRING },
    { name: 'Credential Country', value: 'countryName', type: SmartTable.ColumnTypeId.STRING },
    { name: 'Credential State', value: 'stateName', type: SmartTable.ColumnTypeId.STRING },
    {
      name: 'Required',
      value: row => (row.requiredForOnboarding ? 'Yes' : 'No'),
      type: SmartTable.ColumnTypeId.CUSTOM,
    },
  ];

  constructor(private ngbActiveModal: NgbActiveModal) {}

  close() {
    this.ngbActiveModal.close();
  }
}
